import React, { useEffect, useMemo, useState } from "react";
import ValetApi from "../api/Api";

function formatDateTime(value) {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleString();
}

const ArchiveHealthCard = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [health, setHealth] = useState(null);

    async function fetchHealth() {
        setLoading(true);
        setError("");
        try {
            const res = await ValetApi.getArchiveHealth();
            setHealth(res?.data?.archiveHealth || null);
        } catch (err) {
            setHealth(null);
            const message = err?.[0] || err?.response?.data?.error?.message || "Unable to load archive health";
            setError(message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchHealth();
    }, []);

    const status = useMemo(() => {
        if (error) return { label: "Needs Attention", tone: "red" };
        if (!health) return { label: "Unknown", tone: "yellow" };
        if (!health.configured) return { label: "Not Configured", tone: "red" };
        if (Number(health.rowsOlderThanRetention || 0) > 0 || Number(health.damagePhotosOlderThanRetention || 0) > 0) {
            return { label: "Archive Backlog", tone: "yellow" };
        }
        return { label: "Healthy", tone: "green" };
    }, [error, health]);

    return (
        <div className="archive-health-card">
            <div className="archive-health-header">
                <h4>Archive Health</h4>
                <button
                    type="button"
                    className="archive-health-refresh"
                    onClick={fetchHealth}
                    disabled={loading}>
                    {loading ? "Refreshing..." : "Refresh"}
                </button>
            </div>

            <div className={`archive-health-pill archive-health-pill-${status.tone}`}>{status.label}</div>

            {error ? <div className="archive-health-error">{error}</div> : null}

            {health ? (
                <div className="archive-health-grid">
                    <div>
                        <strong>Retention</strong>: {health.hotDataRetentionDays || "-"} days
                    </div>
                    <div>
                        <strong>Photo Retention</strong>: {health.damagePhotoRetentionDays || "-"} days
                    </div>
                    <div>
                        <strong>Bucket</strong>: {health.bucket || "-"}
                    </div>
                    <div>
                        <strong>Archived Files</strong>: {health.archiveFileCount || 0}
                    </div>
                    <div>
                        <strong>Archived Rows</strong>: {health.archivedRowCount || 0}
                    </div>
                    <div>
                        <strong>Rows Past Retention</strong>: {health.rowsOlderThanRetention || 0}
                    </div>
                    <div>
                        <strong>Photos Past Retention</strong>: {health.damagePhotosOlderThanRetention || 0}
                    </div>
                    <div>
                        <strong>Last Archive Run</strong>: {formatDateTime(health.lastArchiveRunAt)}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default ArchiveHealthCard;
